<template>
    <div>
    <h1>به نرم افزار {{ app_name }} خوش آمدید</h1>
    </div>
</template>

<script>
import Constants from "../Constants";

export default {
  name: "home",
  created: () => {},
  components: {},
  data() {
    return {
      show: true,
      app_name:"",
    };
  },
  mounted(){
    this.app_name = Constants.APP_NAME;
  },
  methods: {},
  beforeMount() {


  }
};
</script>
